import React, { useState, useEffect } from "react";
import "./FpcPage.css";
import BASE_URL from "../apiConfig";
import useRecaptcha from "../hooks/useRecaptcha";
import technopark from "../images/technopark.jpg";

function FpcPage() {

  const [widgetId, setWidgetId] = useState(null);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const { getResponse } = useRecaptcha();

  useEffect(() => {
    if (window.grecaptcha) {
      const container = document.getElementById("recaptcha-fpc");
      if (container && container.innerHTML === "") {
        try {
          const id = window.grecaptcha.render(container, {
            // sitekey: "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI",
             sitekey: window.RECAPTCHA_SITE_KEY,
          });
          setWidgetId(id);
        } catch (err) {
          console.error("reCAPTCHA FpcPage render error:", err);
        }
      }
    }
  }, []);

  const [formData, setFormData] = useState({
    full_name: "",
    phone: "",
    email: "",
    organization: "",
    challenges: ""
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.full_name || !formData.phone) {
      setMessage("❌ Name & Phone required");
      return;
    }

    setLoading(true);

    try {
      const token = getResponse(widgetId);
      if (!token) {
        setMessage("❌ Please complete the reCAPTCHA");
        setLoading(false);
        return;
      }
      const fd = new FormData();
      Object.keys(formData).forEach(k =>
        fd.append(k, formData[k])
      );

      fd.append("_type", "fpc_demo");
      fd.append("tk", token);

      const res = await fetch(
        BASE_URL + "/DemoApi/saveData",
        {
          method: "POST",
          body: fd
        }
      );

      const result = await res.json();

      if (result.status) {
        setMessage("✅ Demo Request Submitted");
        setFormData({
          full_name: "",
          phone: "",
          email: "",
          organization: "",
          challenges: ""
        });
      } else {
        setMessage("❌ " + (result.message || "Verification Failed"));
      }

    } catch (err) {
      console.error("Submission Error:", err);
      setMessage("❌ Submission Failed. Check Console.");
    }

    setLoading(false);
  };

  return (
    <>
      {/* HERO */}
      <div
        className="bg-container-fpc"
        style={{ backgroundImage: `url(${technopark})` }}
      />

      <div className="fpc-wrapper">

        <div className="fpc-left">
          <h1>IGNOSI - PC</h1>
          <h2>Farmer Producer Company Software</h2>

          <p>
            Custom-made for Producer Companies, IGNOSI PC offers a
            multipurpose platform to manage both credit and
            non-credit services including sales, stock purchase,
            deposit management and loan operations through a
            unified digital ecosystem.
          </p>

          <ul>
            <li>Sales & Procurement Management</li>
            <li>Deposit & Loan Services</li>
            <li>Single Balance Sheet Accounting</li>
            <li>Centralized Operations</li>
          </ul>
        </div>

        {/* FORM */}
        <div className="fpc-right">
          <form className="demo-form-fpc" onSubmit={handleSubmit}>

            <input name="full_name"
              placeholder="Full Name*"
              value={formData.full_name}
              onChange={handleChange}
            />

            <input name="phone"
              placeholder="Phone Number*"
              value={formData.phone}
              onChange={handleChange}
            />

            <input name="email"
              placeholder="Email Address"
              value={formData.email}
              onChange={handleChange}
            />

            <input name="organization"
              placeholder="FPC Name"
              value={formData.organization}
              onChange={handleChange}
            />

            <textarea
              name="challenges"
              placeholder="Your challenges"
              value={formData.challenges}
              onChange={handleChange}
            />

            <div
              id="recaptcha-fpc"
              style={{ marginBottom: "15px" }}
            ></div>

            <button disabled={loading}>
              {loading ? "Submitting..." : "Book a Demo"}
            </button>

            {message &&
              <p className="form-msg-fpc">{message}</p>}
          </form>
        </div>

      </div>

      {/* CONTENT SECTIONS */}

      <div className="fpc-content-section">

        <div className="fpc-block">
          <h2>What is PC?</h2>
          <p>
            IGNOSI PC provides a multipurpose platform designed
            specifically for Producer Companies to manage both
            credit and non-credit services. It enables sales,
            procurement, stock purchase, deposits, loans,
            income tracking and expense monitoring through
            consolidated accounting.
          </p>
        </div>

        <div className="fpc-block">
          <h2>Complete Digital Transformation</h2>
          <p>
            Transform your Farmer Producer Company with
            IGNOSI’s centralized platform covering sales,
            procurement, stock management and billing.
            Modules such as Member Management,
            Cheque Book Handling and Automatic Interest
            Calculation ensure operational efficiency.
          </p>
        </div>

        <div className="fpc-block">
          <h2>FPC Registration Support</h2>
          <p>
            We provide complete FPC registration assistance
            through a fully online process ensuring compliance
            readiness without physical presence. Our experts
            guide organizations through incorporation
            requirements and regulatory procedures.
          </p>
        </div>

        <div className="fpc-block">
          <h2>Credit & Non-Credit Management</h2>
          <p>
            Manage sales, billing and procurement effortlessly
            with non-credit modules while credit management
            systems handle deposits, loans and automated
            interest calculations ensuring financial transparency.
          </p>
        </div>

        <div className="fpc-block">
          <h2>Customizable & Scalable Platform</h2>
          <p>
            Built with over 12 years of expertise, IGNOSI FPC
            software supports multi-branch operations,
            advanced reporting and customization tailored
            to organizational requirements.
          </p>
        </div>

        <div className="fpc-block">
          <h2>Your Growth Partner</h2>
          <p>
            Partner with IGNOSI for innovative, sustainable
            and scalable technology solutions that enhance
            productivity and drive long-term growth for
            Farmer Producer Companies.
          </p>
        </div>

      </div>

    </>
  );
}

export default FpcPage;